import { render, staticRenderFns } from "./Banner004Sillas.vue?vue&type=template&id=8322628c"
import script from "./Banner004Sillas.vue?vue&type=script&lang=js"
export * from "./Banner004Sillas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports